document.addEventListener("DOMContentLoaded", () => {

  /* SCROLL ANIMATION */
  const elements = document.querySelectorAll(".fade-up");

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        entry.target.classList.add("active");
      }
    });
  }, { threshold: 0.2 });

  elements.forEach(el => observer.observe(el));


  /* LANGUAGE BUTTON TOGGLE */
  document.querySelectorAll(".lang-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".lang-btn").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
    });
  });


  /* SMOOTH SCROLL TO FORM */
  document.querySelectorAll(".scroll-btn").forEach(btn => {
    btn.addEventListener("click", function(e){
      e.preventDefault();

      const target = document.querySelector("#cl-form");

      if(target){
        const offset = 80; // adjust if header height
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: top,
          behavior: "smooth"
        });

        /* OPTIONAL: highlight form */
        target.classList.add("highlight-form");
        setTimeout(() => {
          target.classList.remove("highlight-form");
        }, 1500);
      }
    });
  });


  /* FORM */
  const form = document.querySelector(".cl-form");
  if(form){
    form.addEventListener("submit", e => {
      e.preventDefault();
      alert("Appointment Booked!");
    });
  }

});